<template>
  <v-card flat dense>
    <v-card-title>
      {{ $t('ITEM.CREATE') }} {{ $t('RELATED_COMPANIES.ITEM') }}
      <v-spacer />
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              :value="name"
              :label="$t('RELATED_COMPANIES.RELATED_TO')"
              disabled
            />
          </v-col>
        </v-row>
        <related-company-form
          v-model="form"
          :errors="errors"
          @input="emitter"
          @update-prop="updateProp(...arguments)"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        color="primary"
        :disabled="!valid"
        @click="createRelatedCompany"
      >
        {{ $t('BUTTON.SAVE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import RelatedCompanyForm from '@/modules/relations/components/forms/RelatedCompanyForm';
import formEditable from '@/modules/_global/mixins/form-editable';

export default {
  name: 'CreateRelatedCompany',

  components: {
    RelatedCompanyForm
  },

  mixins: [formEditable],

  props: {
    name: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      valid: false,
      form: {}
    };
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    createRelatedCompany() {
      this.$emit('create', { ...this.form });
    }
  }
};
</script>
